import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";

type Permission = { id: number; name: string };

type Admin = {
  id: number;
  phone_number: string;
  name: string;
  email: string;
  lead_source: string;
  notes: string;
  address: string;
  branch_name: string;
  admission_number: string;
};

type Disposition = {
  student_disposition_id: number;
  disposition_name: string;
};

type TicketType = {
  ticket_type_id: number;
  ticket_type: string;
};

interface ErrorMessages {
  id?: string[];
  name?: string[];
  phone_number?: string[];
  email?: string[];
  lead_source?: string[];
  notes?: string[];
  address?: string[];
  branch_name?: string[];
  admission_number?: string[];
}

const AddCallParticipant = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const [dispositions, setDispositions] = useState<Disposition[]>([]);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDisposition, setSelectedDisposition] =
    useState<Disposition | null>(null);
  const [typeOfTicket, setTypeOfTicket] = useState<TicketType[]>([]);
  const [selectedTypeOfTicket, setSelectedTypeOfTicket] =
    useState<TicketType | null>(null);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    id: 0,
    name: "",
    phone_number: "",
    email: "",
    lead_source: "",
    notes: "",
    address: "",
    branch_name: "",
    admission_number: "",
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  // const fetchData = async () => {
  //   setIsLoading(true);
  //   try {
  //     const [dispositionsData, typeOfTicketData] = await Promise.all([
  //       fetchDispositions(),
  //       fetchTypeOfTicket(),
  //     ]);
  //     setDispositions(dispositionsData);
  //     setTypeOfTicket(typeOfTicketData);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!checkPermission("add_callparticipant", "callparticipant")) {
      navigate(routes.adminDashboard);
    } else {
    }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/callparticipant/call_participant/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.callParticipantList);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  useEffect(() => {
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Call Participants</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.callParticipantList}>List</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Call Participant</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit} className="d-flex flex-column">
                    <div className="modal-body light-violet-bg d-flex">
                    </div>
                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">SCS Number</label>
                      <input
                        type="text"
                        className={`form-control ${errorMessage.admission_number ? "is-invalid" : ""}`}
                        name="admission_number"
                        placeholder="SCS Number"
                        onChange={handleInputChange}
                        value={newAdmin.admission_number || ""}
                        required
                      />
                      {errorMessage.admission_number && (
                        <div className="invalid-feedback">{errorMessage.admission_number[0]}</div>
                      )}
                    </div>
                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className={`form-control ${errorMessage.name ? "is-invalid" : ""}`}
                        name="name"
                        placeholder="Name"
                        onChange={handleInputChange}
                        value={newAdmin.name || ""}
                        required
                      />
                      {errorMessage.name && (
                        <div className="invalid-feedback">{errorMessage.name[0]}</div>
                      )}
                    </div>
                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Branch</label>
                      <input
                        type="text"
                        className={`form-control ${errorMessage.branch_name ? "is-invalid" : ""}`}
                        name="branch_name"
                        placeholder="Branch"
                        onChange={handleInputChange}
                        value={newAdmin.branch_name || ""}
                        required
                      />
                      {errorMessage.branch_name && (
                        <div className="invalid-feedback">{errorMessage.branch_name[0]}</div>
                      )}
                    </div>

                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className={`form-control ${errorMessage.phone_number ? "is-invalid" : ""}`}
                        name="phone_number"
                        placeholder="Phone Number"
                        onChange={handleInputChange}
                        value={newAdmin.phone_number || ""}
                        inputMode="numeric"              // mobile-friendly numeric keyboard
                        pattern="\d{10}"                 // HTML validation: exactly 10 digits
                        maxLength={10}                   // limits to 10 characters
                        minLength={10}
                        required
                      />
                      {errorMessage.phone_number && (
                        <div className="invalid-feedback">{errorMessage.phone_number[0]}</div>
                      )}
                    </div>

                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className={`form-control ${errorMessage.email ? "is-invalid" : ""}`}
                        name="email"
                        placeholder="Email"
                        onChange={handleInputChange}
                        value={newAdmin.email || ""}
                      // required
                      />
                      {errorMessage.email && (
                        <div className="invalid-feedback">{errorMessage.email[0]}</div>
                      )}
                    </div>

                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Lead Source</label>
                      <input
                        type="text"
                        className={`form-control ${errorMessage.lead_source ? "is-invalid" : ""}`}
                        name="lead_source"
                        placeholder="Lead Source"
                        onChange={handleInputChange}
                        value={newAdmin.lead_source || ""}
                      // required
                      />
                      {errorMessage.lead_source && (
                        <div className="invalid-feedback">{errorMessage.lead_source[0]}</div>
                      )}
                    </div>

                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        className={`form-control ${errorMessage.address ? "is-invalid" : ""}`}
                        name="address"
                        placeholder="Address"
                        onChange={handleInputChange}
                        value={newAdmin.address || ""}
                      // required
                      />
                      {errorMessage.address && (
                        <div className="invalid-feedback">{errorMessage.address[0]}</div>
                      )}
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.callParticipantList}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCallParticipant;
